import { createContext } from 'react';

const initialValue = {
  config: {},
};

const PortletContext = createContext(initialValue);

PortletContext.displayName = 'Portlet';

export default PortletContext;



// WEBPACK FOOTER //
// ./src/js/common/components/Portlet/PortletContext.js